import { useEffect } from 'react'

/**
 * Declaratively manages class names on document.body with automatic unmount cleanup.
 */
export const useBodyClass = (className: string, active: boolean = true) => {
    useEffect(() => {
        if (active) {
            document.body.classList.add(className)
        } else {
            document.body.classList.remove(className)
        }

        return () => {
            document.body.classList.remove(className)
        }
    }, [className, active])
}

export default useBodyClass
